<app-time-off-request-modal
    title="Lieu Day Request"
    [visible]="visible"
    (visibleChange)="visible = $event; visibleChange.emit($event)"
    [isScreenSmall]="!!(screen.xSmallScreenChanged | async)"
    [height]="'auto'"
    [canEdit]="canEdit"
    [canApprove]="canApprove"
    [canDecline]="canDecline"
    [canWithdrawn]="canWithdrawn"
    (save)="onSave()"
    (close)="close()"
    (statusChange)="changeStatus($event)"
    [timeOffRequest]="request"
>
    @if (formData) {
        <div class="row">
            <div class="col-12 mb-3">
                <label class="form-label">Employee*</label>
                <pictured-item-select-box
                    [value]="formData.employee.id"
                    (valueChange)="onEmployeeChange($event)"
                    [dataSource]="employeesDataSource"
                    [readOnly]="!canEditEmployee"
                ></pictured-item-select-box>
            </div>
            <div class="col-12 mb-3">
                <dx-select-box
                    label="Type of Request*"
                    [(value)]="formData.type"
                    [dataSource]="typeOfRequests"
                    displayExpr="text"
                    valueExpr="value"
                    [searchEnabled]="true"
                    [showClearButton]="true"
                    stylingMode="filled"
                    [readOnly]="!canEdit"
                    width="100%"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
            <div class="col-12 mb-3">
                <dx-date-box
                    label="Date*"
                    stylingMode="filled"
                    type="date"
                    [(value)]="formData.requestedDate"
                    (onValueChanged)="onDateChanged($event)"
                    [readOnly]="!canEdit"
                    width="100%"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-date-box>
            </div>
            @if (formData.type == LieuDaySlotType.TakeLieuDay) {
                <div class="col-12 mb-3">
                    <dx-date-box
                        label="Lieu Day to be taken"
                        [value]="lieuDayToBeTaken"
                        [readOnly]="true"
                        stylingMode="filled"
                        width="100%"
                    >
                    </dx-date-box>
                </div>
            }
            @if (formData.type == LieuDaySlotType.BankLieuDay) {
                <div class="col-12 mb-3">
                    <strong>Expiry Date:</strong> {{ formData.expireDate | date: 'longDate' }}
                </div>
            }
            @if (formData.type == LieuDaySlotType.TakeLieuDay) {
                <div class="col-12 mb-3">
                    <strong>Lieu Days Available:</strong> {{ lieuDaysAvailable }}
                </div>
            }
            <div class="col-12 mb-3">
                <dx-text-area
                    label="Description*"
                    stylingMode="filled"
                    [height]="70"
                    [(value)]="formData.description"
                    [readOnly]="!canEdit"
                    width="100%"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-area>
            </div>
        </div>
    }
</app-time-off-request-modal>

